module.exports = __webpack_public_path__ + "img/AminaShaaban.03e75e4f.jpg";